import React, { ReactNode, useCallback, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../utils/hooks/redux";
import { selectAuthRequestStatus, selectAuthStatus, selectUserRole } from "../redux/features/auth/selectors";
import { getProfileInfoThunkAsync } from "../redux/features/auth/authAsyncThunk";
import { RequestResults } from "../redux/common/RequestStatus";
import Header from "../components/Header";
import { Spin } from "antd";
import NotFound from "../pages/NotFound";
import SystemPayRoutes from "../utils/constants/Routes";
import Sidebar from "../components/Sidebar";
import { MainContent } from "../components/Sidebar/styles";

interface PrivateRouteProps {
    element: ReactNode;
    requiredPermission?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element, requiredPermission }) => {
    const isAuthenticated = useAppSelector(selectAuthStatus);
    const status = useAppSelector(selectAuthRequestStatus);
    const userRole = useAppSelector(selectUserRole);
    const dispatch = useAppDispatch();
    const token = localStorage.getItem("authToken");

    const dispatchAuth = useCallback(() => {
        if (token) {
            dispatch(getProfileInfoThunkAsync());
        }
    }, [dispatch, token]);

    useEffect(() => {
        if (status === RequestResults.idle) {
            dispatchAuth();
        }
    }, [status]);

    const hasPermission = useCallback(() => {
        if (!requiredPermission) return true;
        return userRole?.permissionConfigs?.some((config) => config.configKey === requiredPermission);
    }, [requiredPermission, userRole]);

    if ((status === RequestResults.pending || status === RequestResults.idle) && token) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to={SystemPayRoutes.signIn} />;
    }

    if (!hasPermission()) {
        return <NotFound isShowHeader={true} />;
    }

    return (
        <>
            <Sidebar>
                {/* <Header /> */}
                <MainContent>

                {element}
                </MainContent>
            </Sidebar>
        </>
    );
};

export default PrivateRoute;